import { useCallback, useEffect, useState } from 'react';

const TRAINED_KEY = 'infinitsales-agent-trained';
const POST_PROMO_KEY = 'infinitsales-show-training-toast';
const SESSION_DELAY_MS = 800;

export const AGENT_TRAINING_KEYS = {
  TRAINED_KEY,
  POST_PROMO_KEY,
};

export function markAgentTrained() {
  try {
    localStorage.setItem(TRAINED_KEY, 'true');
  } catch {}
}

export function flagShowTrainingToast() {
  try {
    localStorage.setItem(POST_PROMO_KEY, 'true');
  } catch {}
}

export default function useAgentTrainingNotification() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let trained = false;
    try {
      trained = localStorage.getItem(TRAINED_KEY) === 'true';
    } catch {}
    if (trained) return;

    let postPromo = false;
    try {
      postPromo = localStorage.getItem(POST_PROMO_KEY) === 'true';
      if (postPromo) localStorage.removeItem(POST_PROMO_KEY);
    } catch {}

    if (postPromo) {
      setVisible(true);
      return;
    }

    const t = window.setTimeout(() => setVisible(true), SESSION_DELAY_MS);
    return () => window.clearTimeout(t);
  }, []);

  const dismiss = useCallback(() => {
    setVisible(false);
  }, []);

  const markTrained = useCallback(() => {
    markAgentTrained();
    setVisible(false);
  }, []);

  return { visible, dismiss, markTrained };
}
